'use client';

import { useState } from 'react';
import clsx from 'clsx';
import { BarChart3 } from 'lucide-react';
import { PageSection, Reveal, SectionHeading } from '@/components/ui';
import { fadeUp, slideInLeft, slideInRight } from '@/lib/motion';
import s from './IndustryBattleground.module.css';

/**
 * CX battleground intro - left copy + right visual.
 */
export default function IndustryBattleground({
  id = 'battleground',
  bg = 'tint',
  eyebrow,
  title,
  titleAccent,
  paragraph,
  imageSrc,
  imageAlt,
  align = 'left',
  hideImage = false,
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const centered = align === 'center';

  return (
    <PageSection
      id={id}
      bg={bg}
      className={clsx(s.section, bg === 'tint' && s.tintMesh)}
      aria-labelledby="battleground-heading"
    >
      <div
        className={clsx(
          s.introGrid,
          centered && s.introGridCenter,
          hideImage && s.introGridSingle,
        )}
      >
        <Reveal
          variant={hideImage ? fadeUp : slideInLeft}
          className={clsx(s.introLhs, centered && s.centeredIntro)}
        >
          <SectionHeading
            eyebrow={eyebrow}
            title={title}
            titleAccent={titleAccent}
            accentBlock
            size="default"
            align={align}
            headingId="battleground-heading"
          />
          {paragraph && (
            <p className={clsx('type-body', s.sub, centered && s.subCenter)}>{paragraph}</p>
          )}
        </Reveal>

        {!hideImage && (
          <Reveal variant={slideInRight} className={s.introMedia}>
            {imgFailed || !imageSrc ? (
              <div className={s.imagePlaceholder} role="img" aria-label={imageAlt}>
                <BarChart3 size={48} strokeWidth={1.5} aria-hidden="true" />
              </div>
            ) : (
              <img
                src={imageSrc}
                alt={imageAlt || ''}
                draggable={false}
                loading="lazy"
                decoding="async"
                onError={() => setImgFailed(true)}
              />
            )}
          </Reveal>
        )}
      </div>
    </PageSection>
  );
}
